{
    "Accessibility Menu": "Menu d'accessibilité",
    "Reset settings": "Réinitialiser les paramètres",
    "Close": "Fermer",
    "Content Adjustments": "Ajustements de contenu",
    "Adjust Font Size": "Ajuster la taille de police",
    "Highlight Title": "Surligner le titre",
    "Highlight Links": "Surligner les liens",
    "Readable Font": "Police lisible",
    "Color Adjustments": "Ajustements de couleur",
    "Dark Contrast": "Contraste foncé",
    "Light Contrast": "Contraste clair",
    "High Contrast": "Contraste élevé",
    "High Saturation": "Saturation élevée",
    "Low Saturation": "Saturation faible",
    "Monochrome": "Monochrome",
    "Protanopia": "Protanopie",
    "Deuteranopia": "Deutéranopie",
    "Tritanopia": "Tritanopie",
    "Visual & Navigation Aids": "Aides visuelles et de navigation",
    "Additional Tools": "Outils supplémentaires",
    "Reading Guide": "Guide de lecture",
    "Stop Animations": "Arrêter les animations",
    "Big Cursor": "Gros curseur",
    "Screen Reader": "Lecteur d'écran",
    "Hide Images": "Masquer les images",
    "Image Tooltips": "Infobulles d'images",
    "Page Structure": "Structure de la page",
    "Super Focus": "Super Focus",
    "Magnifier": "Loupe",
    "Increase Font Size": "Augmenter la taille de police",
    "Decrease Font Size": "Réduire la taille de police",
    "Letter Spacing": "Espacement des lettres",
    "Line Height": "Hauteur de ligne",
    "Font Weight": "Poids de la police",
    "Dyslexia Font": "Police dyslexie",
    "Language": "Langue",
    "Open Accessibility Menu": "Ouvrir le menu d'accessibilité",
    "Accessibility Profiles": "Profils d'accessibilité",
    "Seizure Safe Profile": "Profil sécurité épilepsie",
    "Stops animations and reduces color saturation.": "Arrête les animations et réduit la saturation des couleurs.",
    "Blind Profile": "Profil pour non-voyants",
    "Activates the screen reader for auditory navigation.": "Active le lecteur d'écran pour la navigation auditive.",
    "Visually Impaired Profile": "Profil malvoyant",
    "Enhances contrast and readability for low vision.": "Améliore le contraste et la lisibilité pour les malvoyants.",
    "ADHD Friendly Profile": "Profil adapté au TDAH",
    "Reduces distractions for better focus.": "Réduit les distractions pour une meilleure concentration.",
    "Cognitive & Learning Profile": "Profil cognitif et apprentissage",
    "Helpful tools for reading and comprehension.": "Outils utiles pour la lecture et la compréhension.",
    "Motor Impaired Profile": "Profil handicap moteur",
    "Optimizes the site for keyboard-only navigation.": "Optimise le site pour la navigation au clavier uniquement.",
    "Headings": "Titres",
    "Landmarks": "Repères",
    "Links": "Liens",
    "Focus element": "Élément ciblé",
    "Visit link": "Visiter le lien"
}